var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.166,
    height: 444.499,
    viewBox: "0 0 234.166 444.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M143.672,463.18H93.623L88.1,457.657V88.023L93.623,82.5h55.969l5.523,5.523v348.9L262.7,263.042l5.92-5.523H315.91l5.92,5.523.435,258.433L316.345,527H260.774l-5.523-5.523-.435-234.544L149.195,457.657Z",
    transform: "translate(-88.1 -82.5)",
    fill: "#0a1e5b",
    opacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoH);
export default __webpack_public_path__ + "static/media/logo-h.3f6ff80513234f86fbffc2e8c15fa22b.svg";
export { ForwardRef as ReactComponent };